import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-tab-panel',
  template: `
    <div
      [id]="'panel-' + value()"
      [attr.role]="'tabpanel'"
      [attr.aria-labelledby]="'tab-' + value()"
      [hidden]="!active()"
    >
      <ng-content />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiTabPanel {
  readonly value = input.required<string>();
  readonly active = input<boolean>(false);
}
